<template>
    <div>
        <div class="search_head">
            <a-form layout="inline" style="padding: 0">
                <a-form-item label="">
                    <a-input v-model="kw" style="width:250px"></a-input>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" html-type="submit" @click="query()">
                        搜索
                    </a-button>
                </a-form-item>
            </a-form>
        </div>
        <div class="search_content">
            <a-table :columns="columns" :data-source="table" bordered size="small" :loading="loading"
                :pagination="pagination" :rowKey="(record, index) => { return index }" @change="change">

            </a-table>
        </div>
    </div>
</template>
<script>
import { get, post } from "../../assets/js/request";
export default {
    data() {
        return {
            kw: '',
            table: [],
            pagination: {
                current: 1,
                pageSize: 20,
                total: 0,
            },
            columns: [
                {
                    title: '序号',
                    customRender: (text, record, index) => `${index + 1}`,
                    width: 50,
                },
                {
                    title: "id",
                    dataIndex: "album_id",
                }, {
                    title: "名称",
                    dataIndex: "name",
                },
                , {
                    title: "关联产品",
                    dataIndex: "link_products",
                }, {
                    title: "时间",
                    dataIndex: "create_time",
                }, {
                    title: "图片数",
                    dataIndex: "image_num",
                }, {
                    title: "视频数",
                    dataIndex: "video_num",
                }
            ],
            loading: false,
        };
    },
    created() {
        this.loadtable();
    },
    methods: {
        loadtable() {
            this.loading = true;
            get("/resource/album_list", {
                page: this.pagination.current,
                size: this.pagination.pageSize,
                search: this.search,
            }).then((res) => {
                this.loading = false;
                this.table = res.data.data;
                let list = res.data.data;
                for (let i = 0; i < list.length; i++) {
                    let link_products = list[i].link_products;
                    var p = [];
                    for (let j = 0; j < link_products.length; j++) {
                        p.push(link_products[j].product_name);
                    }
                    this.table[i].link_products = p.join();
                }
                this.pagination.total = res.data.total;
            });
        },
        change(pagination) {
            this.pagination = pagination;
            this.loadtable();
        },
        query() {
            this.pagination.current = 1;
            this.loadtable();
        },
    },
};
</script>